import { EntitiesList } from '@/common/models';
import { CoreQuery } from '@/common/services/core-query';
import { httpClientCoreQuery } from '../http-client';

export function editTextElement(guid, content) {
    const q = new CoreQuery().path([
        EntitiesList.CONTENT,
        EntitiesList.PERSONA,
        EntitiesList.BUILDER,
        EntitiesList.TEXT,
        guid,
    ]);

    return httpClientCoreQuery.put(q, content);
}
